import type { NotificationType } from '@frontend/api-types';

export const getNotificationCategories = (platform: DuckbillPlatform) => [
  {
    category: 'taskUpdates',
    // We don't render push notifications toggling on web to avoid confusing users
    options: (platform === 'web' ? ['sms', 'email'] : ['push', 'sms', 'email']) as NotificationType[],
    subtitle: 'Action-needed updates, options ready and copilot messages',
    title: 'Task related updates',
  },
  {
    category: 'nudges',
    featureFlag: 'isNudgesEnabled',
    subtitle: 'All marketing communications, including nudges and suggested tasks',
    title: 'Nudges & suggested tasks',
  },
  {
    category: 'birthdays',
    options: ['sms'] as NotificationType[],
    subtitle: "We'll remind you about when your loved ones' birthday is approaching — along with suggested gifts",
    title: 'Birthday reminders',
  },
  {
    category: 'letterRecommendations',
    featureFlag: 'isLetterRecommendationsEnabled',
    // We don't render push notifications toggling on web to avoid confusing users
    options: (platform === 'web' ? ['sms', 'email'] : ['push', 'sms', 'email']) as NotificationType[],
    subtitle: 'Weekly tasks crafted just for you.',
    title: 'Bill’s Weekly Picks',
  },
];
